import React, { useEffect } from 'react';
import './App.css';
import Footer from './GlobalComponents/Footer/Footer';
import Hero from './GlobalComponents/Hero/Hero';
// import Home from './Pages/Home/Home';
// import Portfolio from './Pages/Portfolio/Portfolio';
import { useLocation } from 'react-router-dom';
import AllRoutes from './utils/routes';
import AOS from 'aos';
import 'aos/dist/aos.css';
import bg1 from "../src/Assets/bg1.png"
import contact_img from "../src/Assets/covers/contact.png";
import about_img from "../src/Assets/covers/about.png";
import portfolio_img from "../src/Assets/covers/portfolio.png";
import services_img from "../src/Assets/covers/services.png";
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
import { useTranslation } from "react-i18next";

function App() {
  const { i18n } = useTranslation();  // <-- get i18n instance here

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      easing: 'ease-in-out', // Easing function
      once: true, // Animation happens only once
    });
  }, []);

  useEffect(() => {
    const htmlTag = document.documentElement;
    const currentLang = i18n.language || 'en'; // fallback to 'en'

    // Update lang attribute
    htmlTag.setAttribute("lang", currentLang);

    // Update text direction attribute
    htmlTag.setAttribute("dir", currentLang === "ar" ? "rtl" : "ltr");

    console.log("Set html lang to:", currentLang);
  }, [i18n.language]); // rerun whenever language changes

  return (
    <HelmetProvider>
      <MainContaint />
    </HelmetProvider>
  );
}

const MainContaint = () => {
  const { t } = useTranslation();
  const location = useLocation();
  console.log("Page Path", location.pathname);

  const heroContant = {
    '/': {
      welcomText: t('homeheadings.welcomText'),
      mainHeading: t('homeheadings.mainHeading'),
      subHeading: '',
      heroDesc: '',
      img: bg1
    },
    '/about-us': {
      welcomText: t('aboutusheadings.welcomText'),
      mainHeading: t('aboutusheadings.mainHeading'),
      subHeading: t('aboutusheadings.subHeading'),
      heroDesc: t('aboutusheadings.heroDesc'),
      img: about_img
    },
    '/our-projects': {
      welcomText: t('ourprojectsheadings.welcomText'),
      mainHeading: t('ourprojectsheadings.mainHeading'),
      subHeading: t('ourprojectsheadings.subHeading'),
      heroDesc: t('ourprojectsheadings.heroDesc'),
      img: portfolio_img
    },
    '/services': {
      welcomText: t('servicessheadings.welcomText'),
      mainHeading: t('servicessheadings.mainHeading'),
      subHeading: t('servicessheadings.subHeading'),
      heroDesc: t('servicessheadings.heroDesc'),
      img: services_img
    },
    '/contact-us': {
      welcomText: t('contactusheadings.welcomText'),
      mainHeading: t('contactusheadings.mainHeading'),
      subHeading: t('contactusheadings.subHeading'),
      heroDesc: t('contactusheadings.heroDesc'),
      img: contact_img
    }
  };

  const currentHeroContent = heroContant[location.pathname] || heroContant['/'];

  return (
    <div>
      <Hero
        welcomText={currentHeroContent.welcomText}
        mainHeading={currentHeroContent.mainHeading}
        subHeading={currentHeroContent.subHeading}
        heroDesc={currentHeroContent.heroDesc}
        heroImg={currentHeroContent.img}
      />
      <AllRoutes />
      <Footer />
    </div>
  );
};

export default App;
